/* Supplements the approved variant selector with configuration-specific facts. */
(() => {
  const mount = () => {
    const root = document.querySelector('.fm-page[data-brand="Broil King"]');
    const data = document.querySelector('[data-broil-variant-facts]');
    if (!root || !data) return;
    let records;
    try { records = JSON.parse(data.textContent || '[]'); } catch { return; }
    if (!Array.isArray(records) || !records.length) return;
    const options = root.querySelector('[data-fm-options]');
    const update = () => {
      const sku = root.querySelector('[data-fm-model]')?.textContent.trim();
      const record = records.find(row => row.sku === sku);
      if (!record || !Array.isArray(record.specifications)) return;
      const facts = record.specifications;
      const list = root.querySelector('.fm-specs');
      if (list) {
        const rows = facts.map(fact => {
          const row = document.createElement('div'); row.className = 'fm-spec';
          const label = document.createElement('dt'); label.textContent = fact.label;
          const value = document.createElement('dd'); value.textContent = fact.value;
          row.append(label, value); return row;
        });
        list.querySelectorAll('[data-broil-variant-spec]').forEach(row=>row.remove());for(const row of rows){row.dataset.broilVariantSpec='';const label=row.querySelector('dt').textContent;const existing=[...list.querySelectorAll('.fm-spec')].find(x=>x.querySelector('dt')?.textContent===label);if(existing)existing.replaceWith(row);else list.append(row);}
      }
      root.querySelectorAll('.fm-highlight').forEach(row => {
        const label = row.querySelector('span')?.textContent.trim();
        const fact = facts.find(item => item.label === label);
        if (fact) row.querySelector('strong').textContent = fact.value;
      });
      root.querySelectorAll('[data-compare-product]').forEach(button => {
        try {
          const item = JSON.parse(button.dataset.compareProduct);
          item.specifications = facts;
          button.dataset.compareProduct = JSON.stringify(item);
        } catch { /* An unrelated comparison payload is left intact. */ }
      });
    };
    options?.addEventListener('change', () => queueMicrotask(update));
    options?.addEventListener('fm:select', () => queueMicrotask(update));
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
